// useInitializeCWebCatalog の初期化シングルトン状態を「アプリ(クライアント1タブ)に対して1インスタンス」で保持する。
//
// 【禁止】このシングルトン状態(inflight / forbidden / token 由来データ等)を module スコープ
//        (ファイルトップレベルの let/const)で保持してはならない。SSR が有効になると
//        サーバープロセス上で全リクエスト間で共有され、あるユーザーの in-flight/権限状態が
//        別ユーザーへ漏れる(認証境界を越えた状態リーク)。必ず本プラグインの provide
//        ($cWebCatalogInitStore)経由で per-app に保持すること。
//
// Nuxt プラグインの provide は per-app(= クライアントでは単一タブで1つ / サーバーではリクエスト単位)
// で生成されるため、クライアントサイドでは単一インスタンス、サーバーサイドではリクエスト間で隔離される。
// (本アプリは ssr:false のため実際にはクライアントでのみ生成される)

// 403 Forbidden 追跡・権限変更時の再取得対象となるデータ領域
export type CWebCatalogDomain = "event" | "booth" | "map" | "circleFavorite" | "boothFavorite";

export type CWebCatalogInitStore = {
  // 重い初期データ取得の in-flight Promise(アプリ全体で共有)。
  // 完了(成功/失敗)時に null に戻す。「完了済みか」の判定は bootstrapped で行う。
  inflight: Promise<void> | null
  // 重い初期データ取得が成功で完走したか。inflight とは分離し、
  // 成功後は inflight=null / bootstrapped=true になり、pwaUpdateDefer 側の idle 判定を阻害しない。
  bootstrapped: boolean
  // ブートストラップ時の鍵(`${sub}|${acceptLanguage}`)。ユーザー(sub)や言語が変われば再ブートストラップする
  bootKey: string | null
  // 遷移ごとの鮮度更新 in-flight(連打遷移での重複呼び出しを1本に集約)
  refreshInflight: Promise<unknown> | null
  // 直近に依存データへ適用済みの MapTilesLastModified スナップショット(差分検出用)
  appliedLastModified: number | undefined
  appliedLastModifiedBooth: number | null | undefined
  // 直近の取得で 403 Forbidden だったデータ領域。主に再取得の抑止(毎遷移の 403 連打防止)に使い、
  // 権限(roles)変更時にクリアして再評価する。
  forbidden: Set<CWebCatalogDomain>
  // Event/Base が期間外 (403 + Retry-After) だった。Schedule キャッシュ破棄・再取得の契機。
  eventOutOfPeriod: boolean
  // 直近に適用済みの会員区分(roles)シグネチャ。変化検出で権限変更を判定する
  appliedRolesKey: string | undefined
};

export default defineNuxtPlugin(() => {
  const store: CWebCatalogInitStore = {
    inflight: null,
    bootstrapped: false,
    bootKey: null,
    refreshInflight: null,
    appliedLastModified: undefined,
    appliedLastModifiedBooth: undefined,
    forbidden: new Set(),
    eventOutOfPeriod: false,
    appliedRolesKey: undefined,
  };
  return {
    provide: {
      cWebCatalogInitStore: store,
    },
  };
});
